export default "__VITE_ASSET__c9f15c59__"